// extracted by mini-css-extract-plugin
module.exports = {"icon":"button_icon__1Ktzn","right":"button_right__2HQsj"};